import throttle from '../util/throttle';

const selectors = {
  tooltip: '[data-tooltip]',
  tooltipContainer: '[data-tooltip-container]',
};

const classes = {
  root: 'tooltip-default',
  visible: 'is-visible',
  hiding: 'is-hiding',
};

const attributes = {
  tooltip: 'data-tooltip',
  tooltipContainer: 'data-tooltip-container',
  tooltipStopMouseEnter: 'data-tooltip-stop-mouseenter',
};

const sections = {};

class Tooltip {
  constructor(el) {
    this.tooltip = el;
    if (!this.tooltip.hasAttribute(attributes.tooltip)) {
      return;
    }

    this.rootClass = classes.root;
    this.label = this.tooltip.getAttribute(attributes.tooltip);
    this.transitionSpeed = 200;
    this.hideTransitionTimeout = 0;
    this.addPinEvent = () => this.addPin();
    this.addPinMouseEvent = () => this.addPin(true);
    this.removePinEvent = (event) => throttle(this.removePin(event), 50);
    this.removePinMouseEvent = (event) => this.removePin(event, true, true);
    this.init();
  }

  init() {
    if (!document.querySelector(selectors.tooltipContainer)) {
      const tooltipTemplate = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow"></div><div class="${this.rootClass}__text"></div></div>`;
      const tooltipElement = document.createElement('div');
      tooltipElement.className = this.rootClass;
      tooltipElement.setAttribute(attributes.tooltipContainer, '');
      tooltipElement.innerHTML = tooltipTemplate;
      document.body.appendChild(tooltipElement);
    }

    this.tooltip.addEventListener('mouseenter', this.addPinMouseEvent);
    this.tooltip.addEventListener('mouseleave', this.removePinMouseEvent);
    this.tooltip.addEventListener('theme:tooltip:init', this.addPinEvent);
    document.addEventListener('theme:tooltip:close', this.removePinEvent);
  }

  addPin(stopMouseEnter = false) {
    const tooltipTarget = document.querySelector(selectors.tooltipContainer);

    if (tooltipTarget && ((stopMouseEnter && !this.tooltip.hasAttribute(attributes.tooltipStopMouseEnter)) || !stopMouseEnter)) {
      const tooltipTargetInner = tooltipTarget.querySelector(`.${this.rootClass}__inner`);
      const tooltipTargetText = tooltipTarget.querySelector(`.${this.rootClass}__text`);
      tooltipTargetText.textContent = this.label;

      const tooltipTargetWidth = tooltipTargetInner.offsetWidth;
      const tooltipRect = this.tooltip.getBoundingClientRect();
      const tooltipTop = tooltipRect.top;
      const tooltipWidth = tooltipRect.width;
      const tooltipHeight = tooltipRect.height;
      const tooltipTargetPositionTop = tooltipTop + tooltipHeight + window.scrollY;
      let tooltipTargetPositionLeft = tooltipRect.left - tooltipTargetWidth / 2 + tooltipWidth / 2;
      const tooltipLeftWithWidth = tooltipTargetPositionLeft + tooltipTargetWidth;
      const tooltipTargetWindowDifference = tooltipLeftWithWidth - window.innerWidth;

      if (tooltipTargetWindowDifference > 0) {
        tooltipTargetPositionLeft -= tooltipTargetWindowDifference;
      }

      if (tooltipTargetPositionLeft < 0) {
        tooltipTargetPositionLeft = 0;
      }

      tooltipTarget.style.transform = `translate(${tooltipTargetPositionLeft}px, ${tooltipTargetPositionTop}px)`;
      tooltipTarget.classList.remove(classes.hiding);
      tooltipTarget.classList.add(classes.visible);

      document.addEventListener('theme:scroll', this.removePinEvent);
    }
  }

  removePin(event, stopMouseEnter = false, hideTransition = false) {
    const tooltipTarget = document.querySelector(selectors.tooltipContainer);
    const tooltipVisible = tooltipTarget.classList.contains(classes.visible);

    if (tooltipTarget && ((stopMouseEnter && !this.tooltip.hasAttribute(attributes.tooltipStopMouseEnter)) || !stopMouseEnter)) {
      if (tooltipVisible && (hideTransition || event.detail.hideTransition)) {
        tooltipTarget.classList.add(classes.hiding);

        if (this.hideTransitionTimeout) {
          clearTimeout(this.hideTransitionTimeout);
        }

        this.hideTransitionTimeout = setTimeout(() => {
          tooltipTarget.classList.remove(classes.hiding);
        }, this.transitionSpeed);
      }

      tooltipTarget.classList.remove(classes.visible);

      document.removeEventListener('theme:scroll', this.removePinEvent);
    }
  }

  unload() {
    this.tooltip.removeEventListener('mouseenter', this.addPinMouseEvent);
    this.tooltip.removeEventListener('mouseleave', this.removePinMouseEvent);
    this.tooltip.removeEventListener('theme:tooltip:init', this.addPinEvent);
    document.removeEventListener('theme:tooltip:close', this.removePinEvent);
    document.removeEventListener('theme:scroll', this.removePinEvent);
  }
}

const tooltip = {
  onLoad() {
    sections[this.id] = [];
    const tooltips = this.container.querySelectorAll(selectors.tooltip);
    tooltips.forEach((tooltip) => {
      sections[this.id].push(new Tooltip(tooltip));
    });
  },
  onUnload() {
    sections[this.id].forEach((tooltip) => {
      if (typeof tooltip.unload === 'function') {
        tooltip.unload();
      }
    });
  },
};

export default tooltip;
